import { produce, useOpenDashServices, useTranslation } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { useParams } from "@opendash/router";
import Parse from "parse";
import React, { useState } from "react";
import stc from "string-to-color";

import {
  Avatar,
  Card,
  Checkbox,
  Col,
  Divider,
  Input,
  Layout,
  Row,
  Tooltip,
  Typography,
} from "antd";

import { GBFSConnector, GBFSItem } from "../types";

const { Search } = Input;
const { Content, Sider } = Layout;

export const GBFSConnectorList = (props) => {
  const t = useTranslation();
  const [showLoading, setShowLoading] = useState(false);
  const params = useParams();
  const { SourceService } = useOpenDashServices();
  const [connectors, setConnectors] = useState<GBFSConnector[]>([]);
  const [items, setItems] = useState<Record<string, GBFSItem[]>>({});
  const [filter, setFilter] = useState<string>("");

  const getConnectors = async () => {
    const query = new Parse.Query("OWPlcDevice").startsWith(
      "connectionString",
      "gbfs."
    );
    query.limit(99999);
    const result = await query.find();

    result.forEach(async (connector) => {
      const itemQuery = new Parse.Query("OWPlcItem").equalTo(
        "DeviceID",
        connector
      );
      const items = await itemQuery.find();
      setItems(
        produce((draft) => {
          draft[connector.id] = items.map((item) => {
            const jItem = item.toJSON as unknown;
            return jItem as GBFSItem;
          });
        })
      );
    });

    setConnectors(
      result.map((pObject) => {
        const x = pObject.toJSON() as unknown;
        return x as GBFSConnector;
      })
    );
  };

  React.useEffect(() => {
    getConnectors();
  }, []);

  return (
    <div style={{ padding: "10px" }}>
      <Input
        style={{ width: "100%", marginBottom: 10 }}
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
      ></Input>
      {connectors
        .filter(
          (connector) =>
            connector.name.toLowerCase().indexOf(filter.toLocaleLowerCase()) !==
            -1
        )
        .map((connector: GBFSConnector, index: number) => {
          return (
            <Card
              style={{
                width: 600,
                marginRight: "10",
                marginBottom: 10,
                display: "inline-block",
              }}
              actions={[
                <Icon icon="fa:pencil" />,
                <Icon
                  icon="fa:trash"
                  key="delete"
                  style={{ color: "#ff4d4d" }}
                />,
                connector.enabled ? (
                  <Icon icon="fa:stop" />
                ) : (
                  <Icon icon="fa:play" />
                ),
              ]}
            >
              <Card.Meta
                title={connector.name}
                avatar={
                  <Avatar
                    style={{
                      backgroundColor: stc(connector.name),
                      display: "inline-block",
                    }}
                  >
                    {connector.name
                      .split(" ")
                      .map((part) => part.substring(0, 1))
                      .join("")}
                  </Avatar>
                }
                description={
                  <Typography.Text
                    ellipsis={{ tooltip: connector.connectionString }}
                    copyable={true}
                    style={{ color: "rgba(0,0,0,.45)" }}
                    className="ant-card-meta-description"
                  >
                    {connector.connectionString.substring(5)}
                  </Typography.Text>
                }
              />

              <Divider />
              <Card.Meta description={t("miaas:connector.itemSelect")} />
              <Checkbox.Group
                style={{ width: "100%", marginTop: "10" }}
                onChange={(checkedValues) => {}}
              >
                <Row>
                  <Col span={8}>
                    <Checkbox value="trips">{t("miaas:items.trips")}</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox
                      value="all_locations"
                      disabled={connector.interval < 60000}
                    >
                      {t("miaas:items.all_locations")}
                    </Checkbox>
                    {connector.interval < 60000 && (
                      <Tooltip title={t("miaas:connector.interval.warning")}>
                        <Icon icon="fa:exclamation" />
                      </Tooltip>
                    )}
                  </Col>
                  <Col span={8}>
                    <Checkbox value="changed_locations">
                      {t("miaas:items.changed_location")}
                    </Checkbox>
                  </Col>
                </Row>
              </Checkbox.Group>
            </Card>
          );
        })}
    </div>
  );
};
export default GBFSConnectorList;
